import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class RegistrationStatusUpdateDropdownModule {
}
RegistrationStatusUpdateDropdownModule.ɵfac = function RegistrationStatusUpdateDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationStatusUpdateDropdownModule)(); };
RegistrationStatusUpdateDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RegistrationStatusUpdateDropdownModule });
RegistrationStatusUpdateDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule] });
